import React, { useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
import "./../../../HomePage/Faq/Faq.css";
const SaudiFaqMain = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);
  return (
    <div className="faqMainContainer">
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is Saudi Arabia Attestation and why is it required?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              Saudi Arabia Attestation is the official verification process that
              proves your documents—degree, marriage, birth, commercial
              papers—are genuine and accepted by Saudi authorities. You need
              Saudi attestation for:
              <ul>
                <li> Employment Visa (most common)</li>
                <li> Saudi Culture / Embassy Verification</li>
                <li> Family / Dependent Visa</li>
                <li> School Admissions (children)</li>
                <li> Higher Education</li>
                <li> Business Setup or Commercial Use</li>
              </ul>
              Without attestation, Saudi employers and ministries will reject
              your documents.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is the Saudi Culture Attestation? Is it mandatory?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. For educational certificates, Saudi Arabia requires Saudi
              Culture Attestation before Embassy Attestation. This step
              verifies:
              <ul>
                <li> Your university approval</li>
                <li> Course authenticity</li>
                <li> Marksheets & transcripts</li>
              </ul>
              Without Saudi Culture Attestation, your certificate cannot move to
              MEA or Saudi Embassy steps.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does Saudi Arabia Attestation take in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Timelines vary depending on the document type:
              <ul>
                <li> Educational Certificates: 12–20 working days</li>
                <li> Marriage/Birth Certificates: 10–18 working days</li>
                <li> Commercial Certificates: 12–25 working days</li>
              </ul>
              Urgent/Express service (faster) is available with some agencies.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What documents are required for Saudi Arabia Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              For Educational Documents:
              <ul>
                <li> Original Degree</li>
                <li> All Semester Marksheets</li>
                <li> Offer Letter (sometimes required)</li>
                <li> Passport Copy</li>
                <li> Authorization Letter</li>
              </ul>
              <br />
              For Personal Documents (Birth/Marriage):
              <ul>
                <li> Original Certificate</li>
                <li> Passport Copy</li>
                <li> Aadhar copy</li>
              </ul>
              <br />
              For Commercial Documents:
              <ul>
                <li> Chamber of Commerce letter</li>
                <li> Company registration documents</li>
              </ul>
              Some universities require direct email verification for Saudi
              Culture.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What are the steps in Saudi Arabia Attestation process?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              A complete Saudi attestation process usually includes:
              <b> For Educational Certificates:</b>
              <ul>
                <li> 1. HRD / SDM Validation</li>
                <li>2. University Verification (if needed)</li>
                <li>3. MEA Attestation</li>
                <li>4. Saudi Culture Attestation</li>
                <li>5. Saudi Embassy Attestation</li>
                <li>6. MOFA Attestation – Saudi Arabia</li>
              </ul>
              <br />
              For Personal Certificates:
              <li> Notary</li>
              <li> Home Department / SDM</li>
              <li> MEA</li>
              <li> Saudi Embassy</li>
              <li> MOFA Saudi</li>
              Saudi has one of the strictest attestation processes, so proper
              paperwork is crucial.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is MOFA Attestation (Saudi)? Is it required?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes, extremely important. MOFA (Ministry of Foreign Affairs, Saudi
              Arabia) attests your document after Saudi Embassy completes their
              verification. MOFA attestation is compulsory for:
              <ul>
                <li> Work Visa stamping</li>
                <li> Iqama (residency permit)</li>
                <li> Family visas</li>
                <li> Professional license applications</li>
              </ul>
              Employers in Saudi will not accept documents without MOFA.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Is it safe to give original documents for Saudi Attestation?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes—only when working with a Govt-recognized, ISO-certified
              attestation agency. A good agency will provide:
              <ul>
                {" "}
                <li> Tracking ID</li>
                <li> Receipt for all documents</li>
                <li> Pickup & drop service</li>
                <li> Email/SMS status updates</li>
              </ul>
              Avoid freelancers or agents with no physical office.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Can Saudi Attestation be done without visiting the office?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. In Bangalore, professional agencies offer:
              <li> Free home pick-up & drop</li>
              <li> Fully online documentation process</li>
              <li> Live tracking</li>
              <li> Telephonic support</li>
              <li> WhatsApp status updates</li>
              Convenient for working professionals and families.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is the cost of Saudi Attestation in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Charges depend on document type & urgency:
              <ul>
                {" "}
                <li> Degree Certificate: ₹6,500–₹15,000</li>
                <li> Marriage/Birth: ₹7,000–₹16,000</li>
                <li> Commercial papers: ₹12,000–₹30,000</li>
              </ul>
              <br />
              Express service may cost slightly more. Always check if:
              <ul>
                {" "}
                <li> HRD fees</li>
                <li> MEA fees</li>
                <li> Embassy fees</li>
                <li> Agency service charge</li>
              </ul>
              are included in the quote.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                What are the common mistakes people make before applying for
                Saudi Attestation?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Avoid these common problems that delay attestation:
              <ul>
                <li>  Not getting university transcripts ready</li>
                <li> Mismatch in name across certificates and passport</li>
                <li>
                   Providing laminated certificates (remove lamination!)
                </li>
                <li> Using unverified or freelance agents</li>
                <li> Not checking HRD requirements</li>
                <li> Submitting handwritten certificates</li>
                <li> Delaying MOFA stamping</li>
              </ul>
              A professional attestation center will guide you through all these
              steps to avoid rejection.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
       
      </Accordion>
    </div>
  );
};

export default SaudiFaqMain;
